import { confirm } from '@tauri-apps/plugin-dialog';

export async function rxAlert(message: string, clearDbFn: () => Promise<void>) {
  if (await confirm(message)) {
    await clearDbFn();
  }
}
